import script from "./PersonaCopy.vue?vue&type=script&lang=ts&setup=true"
export * from "./PersonaCopy.vue?vue&type=script&lang=ts&setup=true"

import "./PersonaCopy.vue?vue&type=style&index=0&id=79e66ae5&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79e66ae5"]])

export default __exports__